import { createReducer, on } from '@ngrx/store';
import * as Action from '../actions/app-setting.action';
import textSizeConst from '../../constants/text-size';
export type AppSettingReducerType = {
    textSizeInfo: {
        textSize: number;
        class: {
            maximum4: string;
            maximum3: string;
            maximum2: string;
            maximum1: string;
            maximum: string;
            medium: string;
            minimum: string;
            minimum1: string;
        };
    };
};
export const initialState: AppSettingReducerType = {
    textSizeInfo: {
        textSize: textSizeConst.Medium,
        class: {
            maximum4: 'tss-medium-maximum4',
            maximum3: 'tss-medium-maximum3',
            maximum2: 'tss-medium-maximum2',
            maximum1: 'tss-medium-maximum1',
            maximum: 'tss-medium-maximum',
            medium: 'tss-medium',
            minimum: 'tss-medium-minimum',
            minimum1: 'tss-medium-minimum1',
        },
    },
};

const createRDC = createReducer(
    initialState,
    on(Action.setTextSize, (state, action) => {
        let customClass = state.textSizeInfo.class;
        switch (action.textSize) {
            case textSizeConst.Small:
                customClass = {
                    maximum4: 'tss-small-maximum4',
                    maximum3: 'tss-small-maximum3',
                    maximum2: 'tss-small-maximum2',
                    maximum1: 'tss-small-maximum1',
                    maximum: 'tss-small-maximum',
                    medium: 'tss-small',
                    minimum: 'tss-small-minimum',
                    minimum1: 'tss-small-minimum1',
                };
                break;
            case textSizeConst.Medium:
                customClass = {
                    maximum4: 'tss-medium-maximum4',
                    maximum3: 'tss-medium-maximum3',
                    maximum2: 'tss-medium-maximum2',
                    maximum1: 'tss-medium-maximum1',
                    maximum: 'tss-medium-maximum',
                    medium: 'tss-medium',
                    minimum: 'tss-medium-minimum',
                    minimum1: 'tss-medium-minimum1',
                };
                break;
            case textSizeConst.Large:
                customClass = {
                    maximum4: 'tss-large-maximum4',
                    maximum3: 'tss-large-maximum3',
                    maximum2: 'tss-large-maximum2',
                    maximum1: 'tss-large-maximum1',
                    maximum: 'tss-large-maximum',
                    medium: 'tss-large',
                    minimum: 'tss-large-minimum',
                    minimum1: 'tss-large-minimum1',
                };
                break;
            default:
                break;
        }

        return {
            ...state,
            textSizeInfo: {
                ...state.textSizeInfo,
                textSize: action.textSize,
                class: customClass,
            },
        };
    })
);

export const appSettingReducer = (state, action) => createRDC(state, action);
